export const nav = {
    permission: 'ata.templates:ver',
    section: 'Settings',
    title: 'MinuteTemplates',
    icon: 'description',
    route: '/minute-templates',
    sequence: 22,
};

export default [
    {
        path: '/minute-templates',
        name: 'minute-templates',
        component: () => import('./pages/TemplatesPage.vue'),
        meta: { requiresAuth: true, permission: 'ata.templates:ver' },
    },
];
